module.exports = __webpack_public_path__ + "d9798c9afdcdee6af51f7ddfd55a5b36.svg";